import EverTrue from 'app';

const container = {
  textAlign: 'center',
};

const linkStyle = {
  color: '#3367F2',
  textDecoration: 'underline',
};

const button = {
  backgroundColor: '#3367F2',
  color: '#fff',
  padding: '10px 16px',
  borderRadius: '100px',
  textDecoration: 'none',
  fontSize: '16px',
  fontWeight: '400',
  cursor: 'pointer',
  display: 'inline-block',
};

const imgStyle = {
  display: 'block',
  margin: '0 auto',
};

const PATH = 'https://thankview.com/video/signal/';

const copyVideo = (videoIdString, videoUrl, settings, styles) => {
  EverTrue.track.set('signal_video', { type: 'signal_video_copy' });
  let url = `${PATH}${videoIdString}`;
  const convertStyleObjectToCss = (styleObject) => {
    return Object.entries(styleObject)
      .map(([key, value]) => `${key.replace(/([A-Z])/g, '-$1').toLowerCase()}:${value}`)
      .join(';');
  };

  const copyGifThumbnailWithHtml = async () => {
    try {
      let htmlToAppend = `
        <div style="${convertStyleObjectToCss(container)}">
          <a href="${url}" style="text-decoration: none;">
            <img 
              src="${videoUrl}" 
              alt="Video Thumbnail" 
              style="${convertStyleObjectToCss(imgStyle)}"
            >
          </a>
          <br>
          <div>
            Click <a href="${url}" style="${convertStyleObjectToCss(linkStyle)}">here</a> to see your video!
          </div>
      `;
      if (settings.button_text && settings.show_in_email) {
        const btnHTML = `
          <br>
          <a 
            href="${settings.button_url}" 
            target="_blank" 
            rel="noopener noreferrer" 
            style="${convertStyleObjectToCss({ ...button })}"
          >
            ${settings.button_text.trim()}
          </a>
        </div>
        <div><br></div>
        `;
        htmlToAppend += btnHTML;
      } else htmlToAppend += '</div><div><br></div>';

      if (navigator.clipboard && window.ClipboardItem) {
        const clipboardItem = new ClipboardItem({
          'text/html': new Blob([htmlToAppend], { type: 'text/html' }),
        });
        await navigator.clipboard.write([clipboardItem]);
      } else {
        // Fallback for browsers that don't support ClipboardItem
        const tempElem = document.createElement('div');
        tempElem.innerHTML = htmlToAppend;
        document.body.appendChild(tempElem);
        const range = document.createRange();
        range.selectNodeContents(tempElem);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        document.body.removeChild(tempElem);
      }

      EverTrue.Alert.success('Video successfully copied to clipboard');
      return true;
    } catch (err) {
      EverTrue.Alert.error(`Failed to copy video to clipboard ${err}`);
    }
  };

  return copyGifThumbnailWithHtml();
};

export default copyVideo;
